<div class="tab-container">
  <div class="tab-container__column bottom-spacer">
    @if (!isLEP) {
      <div class="bottom-spacer">
        <div class="tab-container__details card-surface">
          <p class="header top">Events details</p>
          @if (eventScheduleDetails) {
            <div class="details-table">
              <div class="tr">
                <div class="event-details-column">
                  <div class="event-detail">
                    <img class="icon" src="/shared/svg/help_rounded.svg" />
                    <div class="th">
                      <span class="mat-label-medium">Entry Fee</span>
                      <div class="td">
                        <fz-currency
                          [value]="eventScheduleDetails.entryAmount"
                        ></fz-currency>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="event-details-column">
                  <div class="event-detail">
                    <img class="icon" src="/shared/svg/account_circle.svg" />
                    <div class="th mat-label-medium">
                      Seats
                      <div class="td">
                        {{ eventScheduleDetails.totalEntryCount }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="tab-container__prizes card-surface unstyled-table">
          <p class="header top m-b">Winner Prizes</p>
          <fz-prize-details
            [prizeDetails]="getOrderedPrizeDetails()"
          ></fz-prize-details>
        </div>
      </div>
    } @else {
      <div class="tab-container__lept-content bottom-spacer">
        @if (showListPrizes()) {
          <div class="bottom-spacer">
            <div class="card-surface winner-prizes unstyled-table">
              <h1 class="header mat-headline-mediumtop">Winner Prizes</h1>
              <fz-prize-details
                [prizeDetails]="getOrderedPrizeDetails()"
                [isLifeExperience]="true"
              ></fz-prize-details>
            </div>
          </div>
        }
        <mat-card appearance="outlined" class="card-surface prize-details">
          <h1 class="header">Prize Details</h1>
          <div class="prize-details__content">
            <div
              class="prize-details__content__item"
              fxFlex.gt-md="45"
              fxFlex.lt-md="50"
              fxFlex.xs="100"
            >
              <img
                class="prize-full-size"
                [src]="prizeImageFullSize"
                alt="Prize"
              />
            </div>
            <div
              class="prize-details__content__item"
              fxFlex.gt-md="50"
              fxFlex.lt-md="50"
              fxFlex.xs="100"
            >
              <div class="prize-name">
                <p>{{ eventScheduleDetails?.firstPrize?.prizeName }}</p>
                <p class="">
                  {{ eventScheduleDetails?.firstPrize?.prizeDetails }}
                </p>
              </div>
            </div>
          </div>
        </mat-card>

        @if (eventScheduleDetails?.firstPrize?.technicalDetails) {
          <div class="card-surface technical-details">
            <div>
              <h2 class="header">Technical Details</h2>
              <div
                class="details"
                [innerHTML]="eventScheduleDetails?.firstPrize?.technicalDetails"
              ></div>
            </div>
          </div>
        }
        <div class="card-surface market-value">
          <div>
            <h2 class="header">Estimated Market Value</h2>
            <div class="details">
              <fz-currency
                [value]="eventScheduleDetails?.firstPrize?.prizeValue"
              ></fz-currency>
            </div>
          </div>
        </div>
      </div>
    }
    <ng-container *ngTemplateOutlet="playControls"></ng-container>
  </div>
  <div class="tab-container__column summary column">
    <fz-score-summary
      [eventCode]="eventCode"
      [showSummary]="showSummary"
      [eventScheduleDetails]="this.eventScheduleDetails"
      [bestScore]="bestScores"
      [isLEP]="isLEP"
      [seats]="eventScheduleDetails?.totalEntryCount"
      [prizeImage]="prizeImage"
      [prizeValue]="eventScheduleDetails?.firstPrize?.prizeValue"
      [entryAmount]="eventScheduleDetails?.entryAmount"
      assetUrl="{{ assetUrl }}"
      [metadata]="details?.metadata"
    ></fz-score-summary>
  </div>
</div>
